<app-header-tela [titulo]="'Avaliações'"></app-header-tela>

<div class="container p-2 avaliacoes-loja">
  <div class="resumo" *ngIf="total">
    <span class="resumo-media">{{media | number: '1.1-1'}}</span>
    <div class="resumo-detalhe">
      <span class="estrelas estrelas-grandes" [attr.aria-label]="'Nota ' + (media | number: '1.1-1') + ' de 5'">
        <span class="estrelas-fundo" aria-hidden="true">&#9733;&#9733;&#9733;&#9733;&#9733;</span>
        <span class="estrelas-cheias" aria-hidden="true" [style.width.%]="percentualEstrelas(media)">&#9733;&#9733;&#9733;&#9733;&#9733;</span>
      </span>
      <span class="resumo-total">{{total}} {{total === 1 ? 'avaliação de cliente' : 'avaliações de clientes'}}</span>
    </div>
  </div>

  <ul class="lista" *ngIf="avaliacoes.length">
    <li class="avaliacao" *ngFor="let avaliacao of avaliacoes">
      <span class="avatar" aria-hidden="true">{{inicial(avaliacao.nome)}}</span>
      <div class="avaliacao-corpo">
        <div class="avaliacao-topo">
          <span class="nome">{{avaliacao.nome}}</span>
          <span class="data">{{dataRelativa(avaliacao.data)}}</span>
        </div>
        <span class="estrelas" [attr.aria-label]="'Nota ' + avaliacao.nota + ' de 5'">
          <span *ngFor="let estrela of estrelas" aria-hidden="true" [class.cheia]="estrela <= avaliacao.nota">&#9733;</span>
        </span>
        <p class="comentario" *ngIf="avaliacao.comentario">{{avaliacao.comentario}}</p>
      </div>
    </li>
  </ul>

  <div class="estado" *ngIf="carregou && !carregando && !avaliacoes.length && !erro">
    <span class="estado-estrela" aria-hidden="true">&#9733;</span>
    <span class="estado-titulo">Ainda não há avaliações por aqui</span>
    <span>Quando a loja publicar as avaliações dos clientes, elas aparecem nesta página.</span>
  </div>

  <div class="estado" *ngIf="erro">
    <span>{{erro}}</span>
  </div>

  <div class="rodape" *ngIf="temMais || erro || (carregando && !avaliacoes.length)">
    <button type="button" class="btn btn-outline-secondary btn-block" [disabled]="carregando" (click)="carregueMais()">
      <i class="fas fa-spinner fa-spin mr-1" *ngIf="carregando"></i>
      {{carregando ? 'Carregando…' : (erro ? 'Tentar de novo' : 'Ver mais avaliações')}}
    </button>
  </div>
</div>
